import { RecordingsReducerState } from './recordingReducer';
import { MissingRecording, IncorrectRecording } from '../../ErrorReporting/types';

export const isResolveButtonEnabled = (
  recordingReducerState: RecordingsReducerState,
  recordings: MissingRecording[] | IncorrectRecording[],
) =>
  recordingReducerState.anyRecordingsChecked &&
  recordings
    .filter((recording) => recordingReducerState.recordings[recording.recordingGid])
    .every((recording) => !recording.resolved);

export const isUnresolveButtonEnabled = (
  recordingReducerState: RecordingsReducerState,
  recordings: MissingRecording[] | IncorrectRecording[],
) =>
  recordingReducerState.anyRecordingsChecked &&
  recordings
    .filter((recording) => recordingReducerState.recordings[recording.recordingGid])
    .every((recording) => recording.resolved);
